import * as regExp from "../../constants/regExp";

/**
 * Ckeck if passed "email" string is a valid email address
 * Tests email with "/constant/regExp.EMAIL"
 * @param email Email to test
 * @returns A boolean value of test result
 */
export const isEmailValid = (email) => regExp.EMAIL.test(email?.trim() || "");
